@let r = route();
<div class="buupass-container">
  <ul class="fr-stats" aria-label="Route facts">
    <li>
      <span class="fr-stats__icon"><app-icon name="clock" /></span>
      <span><small>Flight time</small><strong>{{ r.flightTime }}</strong></span>
    </li>
    <li>
      <span class="fr-stats__icon"><app-icon name="ruler" /></span>
      <span><small>Distance</small><strong>{{ r.distanceKm | number }} km</strong></span>
    </li>
    <li>
      <span class="fr-stats__icon"><app-icon name="takeoff" /></span>
      <span><small>Airlines</small><strong>{{ r.airlines.length }} {{ r.airlines.length === 1 ? 'airline' : 'airlines' }}</strong></span>
    </li>
    <li>
      <span class="fr-stats__icon"><app-icon name="ticket" /></span>
      <span><small>Pay with</small><strong>M-Pesa or card</strong></span>
    </li>
  </ul>

  <div class="fr-layout">
    <div class="fr-main">
      <section class="fr-card">
        <h2>About {{ r.from.city }} to {{ r.to.city }} flights</h2>
        @for (paragraph of r.intro.slice(1); track $index) {
          <p>{{ paragraph }}</p>
        }
        <ul class="fr-checks">
          @for (item of r.highlights; track item) {
            <li><span class="fr-checks__icon"><app-icon name="check" /></span>{{ item }}</li>
          }
        </ul>
      </section>

      <section class="fr-card">
        <h2>Tips for booking a cheap flight to {{ r.to.city }}</h2>
        <ol class="fr-tips">
          @for (tip of r.tips; track tip; let i = $index) {
            <li>
              <span class="fr-tips__num" aria-hidden="true">{{ i + 1 }}</span>
              <p>{{ tip }}</p>
            </li>
          }
        </ol>
      </section>

      <section class="fr-card fr-faq">
        <h2>{{ r.from.city }} to {{ r.to.city }} flights: FAQs</h2>
        @for (item of r.faq; track item.q; let first = $first) {
          <details [open]="first">
            <summary>
              {{ item.q }}
              <app-icon name="chevron" class="fr-faq__chevron" />
            </summary>
            <p>{{ item.a }}</p>
          </details>
        }
      </section>
    </div>

    <aside class="fr-aside">
      <section class="fr-card fr-glance">
        <h2>Route at a glance</h2>
        <dl>
          <div>
            <dt><app-icon name="takeoff" /> From</dt>
            <dd>{{ r.from.airport }} <span>({{ r.from.iata }})</span></dd>
          </div>
          <div>
            <dt><app-icon name="pin" /> To</dt>
            <dd>{{ r.to.airport }} <span>({{ r.to.iata }})</span></dd>
          </div>
          <div>
            <dt><app-icon name="clock" /> Flight time</dt>
            <dd>{{ r.flightTime }}</dd>
          </div>
        </dl>
        <p class="fr-glance__label">Airlines on this route</p>
        <ul class="fr-chips">
          @for (airline of r.airlines; track airline) {
            <li>{{ airline }}</li>
          }
        </ul>
        <button type="button" class="fr-cta" (click)="scrollToSearch()">
          <app-icon name="search" /> Search {{ r.to.city }} flights
        </button>
        <p class="fr-glance__pay"><app-icon name="shield" /> Pay with M-Pesa, Airtel Money, Visa or Mastercard. E-ticket by email and SMS.</p>
      </section>

      @if (r.busUrl) {
        <a class="fr-card fr-bus" [href]="r.busUrl">
          <span class="fr-bus__icon"><app-icon name="bus" /></span>
          <span>
            <strong>Travelling by road instead?</strong>
            <span>Compare {{ r.from.city }} to {{ r.to.city }} buses on BuuPass</span>
          </span>
          <app-icon name="arrow" class="fr-bus__arrow" />
        </a>
      }

      @if (international()) {
        <div class="fr-card fr-note" role="note">
          <app-icon name="info" />
          <p>Check passport, visa and vaccination requirements before you travel internationally.</p>
        </div>
      }
    </aside>
  </div>

  <section class="fr-related">
    <h2>More flight routes</h2>
    <div class="fr-related__grid">
      @for (other of related(); track other.slug) {
        <app-route-card [route]="other" />
      }
    </div>
  </section>
</div>
